import { useContext } from "react";
import useErrorHandler from "@beeldit/core/errors/useErrorHandler";
import { GenerateDeliveryNoteActionContext } from "./GenerateDeliveryNoteActionContext";
import store from "@beeldit/core/services/store";
import { BulkActionActionContext } from "@beeldit/core/context/BulkActionContext";

function useGenerateDeliveryNote(modelConfig: any) {
  const { setShowModal, setLoading, generatePdf, sendToCustomer, separatedInvoices } = useContext(GenerateDeliveryNoteActionContext);
  const { elementIds } = useContext(BulkActionActionContext);
  const errorHandler = useErrorHandler();
  return (onSuccess: any) => {
    setLoading(true);
    store("invoices/generate", { 
      element_ids: elementIds, 
      invoice_type_id: 5,
      generate_pdf: generatePdf,
      send_to_customer: sendToCustomer,
      separated_invoices: separatedInvoices
    })
      .then((response: any) => {
        setShowModal(false);
        onSuccess();
      })
      .catch((error: any) => {
        errorHandler(error);
      })
      .finally(() => {
        setLoading(false);
      });
  };
}

export default useGenerateDeliveryNote;
